// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__FgAXo","search":"search_search__KL3TJ","filter":"search_filter__QvJI0","active":"search_active__0NGUK","group":"search_group___h1QI"};